import { Flex } from 'antd';
import styled from 'styled-components';

export const Container = styled(Flex)`
  width: 100%;
  max-width: 1104px;
  margin: 0 auto;
  @media (max-width: 1440px) {
    margin: 0 20px;
  }
`;

export const SectionTitle = styled.p`
  margin: 0;
  line-height: 24px;
  font-size: 18px;
  font-weight: 500;
  color: ${(props) => props.theme.antd?.colorPrimary};
`;
